module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(!_vm.visible) ? _c('button', {
    staticClass: "mode-switcher__toggle",
    on: {
      "click": function($event) {
        _vm.visible = !_vm.visible
      }
    }
  }, [_c('svg', {
    attrs: {
      "width": "777",
      "height": "681",
      "viewBox": "0 0 777 681",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M209.662 0h357.68c11.007 0 21.212 5.857 26.67 15.414l178.872 309.688a30.917 30.917 0 0 1 0 30.826l-178.872 309.66C588.554 675.145 578.38 681 567.342 681h-357.68c-11.009 0-21.215-5.855-26.673-15.412L4.117 355.928a30.91 30.91 0 0 1 0-30.826L182.989 15.414C188.478 5.857 198.653 0 209.662 0zm178.839 155.585c-102.031 0-185.008 82.954-185.008 184.96 0 102.008 82.977 184.963 185.008 184.963 102.001 0 185.007-82.955 185.007-184.962 0-102.007-82.975-184.961-185.007-184.961z",
      "fill": "#FFF",
      "fill-rule": "nonzero"
    }
  })])]) : _vm._e(), _vm._v(" "), _c('div', {
    class: ['mode-switcher', _vm.visible ? 'visible' : '']
  }, [_c('transition', {
    attrs: {
      "name": "mode-switcher-vignette-transition"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.visible),
      expression: "visible"
    }],
    staticClass: "mode-switcher__vignette",
    on: {
      "click": function($event) {
        _vm.visible = false
      }
    }
  })]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "mode-switcher-content-transition"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.visible),
      expression: "visible"
    }],
    staticClass: "mode-switcher__content"
  }, [_c('button', {
    staticClass: "mode-switcher__close",
    on: {
      "click": function($event) {
        _vm.visible = false
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-times"
  })]), _vm._v(" "), _c('div', {
    staticClass: "mode-switcher__content__block"
  }, [_c('h3', {
    staticClass: "mode-switcher__content__block__header large centered"
  }, [_vm._v("Prototype preferences")])]), _vm._v(" "), _c('div', {
    staticClass: "mode-switcher__divider"
  }), _vm._v(" "), _c('div', {
    staticClass: "mode-switcher__content__columns"
  }, [_c('div', {
    staticClass: "mode-switcher__content__columns__column"
  }, [_c('div', {
    staticClass: "mode-switcher__content__block"
  }, [_c('h3', {
    staticClass: "mode-switcher__content__block__header"
  }, [_vm._v("Preset")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.currentPreset),
      expression: "currentPreset"
    }],
    staticClass: "mode-switcher__select",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.currentPreset = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.presets), function(preset) {
    return _c('option', {
      domProps: {
        "value": preset.value
      }
    }, [_vm._v("\n                                    " + _vm._s(preset.label) + "\n                                ")])
  })), _c('br'), _c('br'), _vm._v(" "), _c('a', {
    on: {
      "click": function($event) {
        _vm.advanced = !_vm.advanced
      }
    }
  }, [_vm._v(_vm._s(_vm.advanced ? 'Hide advanced options' : 'Show advanced options'))])]), _vm._v(" "), (false) ? _c('div', {
    staticClass: "mode-switcher__content__block border-top"
  }, [_c('h3', {
    staticClass: "mode-switcher__content__block__header"
  }, [_vm._v("Demo")]), _vm._v(" "), _c('iframe', {
    attrs: {
      "src": "https://player.vimeo.com/video/208475715",
      "frameborder": "0",
      "webkitallowfullscreen": "",
      "mozallowfullscreen": "",
      "allowfullscreen": ""
    }
  })]) : _vm._e()]), _vm._v(" "), (_vm.advanced) ? _c('div', {
    staticClass: "mode-switcher__content__columns__column"
  }, [_c('div', {
    staticClass: "mode-switcher__content__block"
  }, [_c('h3', {
    staticClass: "mode-switcher__content__block__header"
  }, [_vm._v("Choose universal navigation mode")]), _vm._v(" "), _c('div', {
    staticClass: "mode-switcher__form-groups"
  }, _vm._l((_vm.availableModes), function(mode) {
    return _c('label', {
      staticClass: "mode-switcher__form-group"
    }, [_c('div', {
      staticClass: "mode-switcher__form-group__radio"
    }, [_c('input', {
      attrs: {
        "type": "radio",
        "name": "mode"
      },
      domProps: {
        "checked": mode.key === _vm.currentMode,
        "value": mode.key
      },
      on: {
        "change": function () { return _vm.onChangeMode(mode.key); }
      }
    }), _vm._v(" "), (mode.key === _vm.currentMode) ? _c('div', {
      staticClass: "mode-switcher__form-group__icon mode-switcher__form-group__icon__selected"
    }, [_c('i', {
      class: ['fa', 'outer', 'fa-circle']
    }), _vm._v(" "), _c('i', {
      class: ['fa', 'inner', 'fa-circle']
    })]) : _vm._e(), _vm._v(" "), (mode.key !== _vm.currentMode) ? _c('i', {
      class: ['fa', 'mode-switcher__form-group__icon', 'fa-circle']
    }) : _vm._e()]), _vm._v(" "), (mode.image && false) ? _c('div', {
      staticClass: "mode-switcher__form-group__image large"
    }, [_c('img', {
      attrs: {
        "src": mode.image,
        "alt": ""
      }
    })]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "mode-switcher__form-group__content"
    }, [_c('h4', [_vm._v(_vm._s(mode.label))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(mode.description))])])])
  }))]), _vm._v(" "), (false) ? _c('div', {
    staticClass: "mode-switcher__content__block"
  }, [_c('h3', {
    staticClass: "mode-switcher__content__block__header"
  }, [_vm._v("Alt-key action")]), _vm._v(" "), _c('div', {
    staticClass: "mode-switcher__form-groups"
  }, _vm._l((_vm.altClickModes), function(mode) {
    return _c('label', {
      staticClass: "mode-switcher__form-group"
    }, [_c('div', {
      staticClass: "mode-switcher__form-group__radio"
    }, [_c('input', {
      attrs: {
        "type": "radio",
        "name": "mode"
      },
      domProps: {
        "checked": mode.key === _vm.currentAltClickMode,
        "value": mode.key
      },
      on: {
        "change": function () { return _vm.onChangeAltClickMode(mode.key); }
      }
    }), _vm._v(" "), (mode.key === _vm.currentAltClickMode) ? _c('div', {
      staticClass: "mode-switcher__form-group__icon mode-switcher__form-group__icon__selected"
    }, [_c('i', {
      class: ['fa', 'outer', 'fa-circle']
    }), _vm._v(" "), _c('i', {
      class: ['fa', 'inner', 'fa-circle']
    })]) : _vm._e(), _vm._v(" "), (mode.key !== _vm.currentAltClickMode) ? _c('i', {
      class: ['fa', 'mode-switcher__form-group__icon', 'fa-circle']
    }) : _vm._e()]), _vm._v(" "), (mode.image && false) ? _c('div', {
      staticClass: "mode-switcher__form-group__image large"
    }, [_c('img', {
      attrs: {
        "src": mode.image,
        "alt": ""
      }
    })]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "mode-switcher__form-group__content"
    }, [_c('h4', [_vm._v(_vm._s(mode.label))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(mode.description))])])])
  }))]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.advanced) ? _c('div', {
    staticClass: "mode-switcher__content__columns__column"
  }, [_c('div', {
    staticClass: "mode-switcher__content__block"
  }, [_c('h3', {
    staticClass: "mode-switcher__content__block__header"
  }, [_vm._v("Choose back button layout")]), _vm._v(" "), _c('div', {
    staticClass: "mode-switcher__form-groups"
  }, _vm._l((_vm.backButtonBehaviors), function(behavior) {
    return _c('label', {
      staticClass: "mode-switcher__form-group"
    }, [_c('div', {
      staticClass: "mode-switcher__form-group__radio"
    }, [_c('input', {
      attrs: {
        "type": "radio",
        "name": "mode"
      },
      domProps: {
        "checked": behavior.key === _vm.currentBackButtonBehavior,
        "value": behavior.key
      },
      on: {
        "change": function () { return _vm.onChangeBackButtonBehavior(behavior.key); }
      }
    }), _vm._v(" "), (behavior.key === _vm.currentBackButtonBehavior) ? _c('div', {
      staticClass: "mode-switcher__form-group__icon mode-switcher__form-group__icon__selected"
    }, [_c('i', {
      class: ['fa', 'outer', 'fa-circle']
    }), _vm._v(" "), _c('i', {
      class: ['fa', 'inner', 'fa-circle']
    })]) : _vm._e(), _vm._v(" "), (behavior.key !== _vm.currentBackButtonBehavior) ? _c('i', {
      class: ['fa', 'mode-switcher__form-group__icon', 'fa-circle']
    }) : _vm._e()]), _vm._v(" "), (behavior.image && false) ? _c('div', {
      staticClass: "mode-switcher__form-group__image small"
    }, [_c('img', {
      attrs: {
        "src": behavior.image,
        "alt": ""
      }
    })]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "mode-switcher__form-group__content"
    }, [_c('h4', [_vm._v(_vm._s(behavior.label))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(behavior.description))])])])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "mode-switcher__content__block border-top"
  }, [_c('h3', {
    staticClass: "mode-switcher__content__block__header"
  }, [_vm._v("Choose context switcher layout")]), _vm._v(" "), _c('div', {
    staticClass: "mode-switcher__form-groups"
  }, _vm._l((_vm.switcherLayouts), function(switcherLayout) {
    return _c('label', {
      staticClass: "mode-switcher__form-group"
    }, [_c('div', {
      staticClass: "mode-switcher__form-group__radio"
    }, [_c('input', {
      attrs: {
        "type": "radio",
        "name": "mode"
      },
      domProps: {
        "checked": switcherLayout.key === _vm.currentSwitcherLayout,
        "value": switcherLayout.key
      },
      on: {
        "change": function () { return _vm.onChangeSwitcherLayout(switcherLayout.key); }
      }
    }), _vm._v(" "), (switcherLayout.key === _vm.currentSwitcherLayout) ? _c('div', {
      staticClass: "mode-switcher__form-group__icon mode-switcher__form-group__icon__selected"
    }, [_c('i', {
      class: ['fa', 'outer', 'fa-circle']
    }), _vm._v(" "), _c('i', {
      class: ['fa', 'inner', 'fa-circle']
    })]) : _vm._e(), _vm._v(" "), (switcherLayout.key !== _vm.currentBackButtonBehavior) ? _c('i', {
      class: ['fa', 'mode-switcher__form-group__icon', 'fa-circle']
    }) : _vm._e()]), _vm._v(" "), (switcherLayout.image) ? _c('div', {
      staticClass: "mode-switcher__form-group__image small"
    }, [_c('img', {
      attrs: {
        "src": switcherLayout.image,
        "alt": ""
      }
    })]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "mode-switcher__form-group__content"
    }, [_c('h4', [_vm._v(_vm._s(switcherLayout.label))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(switcherLayout.description))])])])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "mode-switcher__content__block border-top"
  }, [_c('h3', {
    staticClass: "mode-switcher__content__block__header"
  }, [_vm._v("Choose \"Show all\" behavior\"")]), _vm._v(" "), _c('div', {
    staticClass: "mode-switcher__form-groups"
  }, _vm._l((_vm.showAllBehaviors), function(showAllBehavior) {
    return _c('label', {
      staticClass: "mode-switcher__form-group"
    }, [_c('div', {
      staticClass: "mode-switcher__form-group__radio"
    }, [_c('input', {
      attrs: {
        "type": "radio",
        "name": "mode"
      },
      domProps: {
        "checked": showAllBehavior.key === _vm.currentShowAllBehavior,
        "value": showAllBehavior.key
      },
      on: {
        "change": function () { return _vm.onChangeShowAllBehavior(showAllBehavior.key); }
      }
    }), _vm._v(" "), (showAllBehavior.key === _vm.currentShowAllBehavior) ? _c('div', {
      staticClass: "mode-switcher__form-group__icon mode-switcher__form-group__icon__selected"
    }, [_c('i', {
      class: ['fa', 'outer', 'fa-circle']
    }), _vm._v(" "), _c('i', {
      class: ['fa', 'inner', 'fa-circle']
    })]) : _vm._e(), _vm._v(" "), (showAllBehavior.key !== _vm.currentShowAllBehavior) ? _c('i', {
      class: ['fa', 'mode-switcher__form-group__icon', 'fa-circle']
    }) : _vm._e()]), _vm._v(" "), (showAllBehavior.image) ? _c('div', {
      staticClass: "mode-switcher__form-group__image small"
    }, [_c('img', {
      attrs: {
        "src": showAllBehavior.image,
        "alt": ""
      }
    })]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "mode-switcher__form-group__content"
    }, [_c('h4', [_vm._v(_vm._s(showAllBehavior.label))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(showAllBehavior.description))])])])
  }))])]) : _vm._e()])])])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c52005b8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ModeSwitcher/index.vue
// module id = 466
// module chunks = 1